export default __webpack_public_path__ + "static/media/xbox-logo.a7375378.svg";